// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__W1N5j"};